import { inject, Injector } from '@angular/core';

import { Subject } from 'rxjs';

import { I18nService } from '@core/i18n-legacy';
import { UserProfileTab } from '@core/tellent-types';
import { DialogService, DialogWidth, RtPlatform } from '@core/user-interface-legacy';

import { CurrentUserProfileDialogComponent } from './current-user-profile-dialog.component';

export function withCurrentUserProfileDialogOpener(profileCloseNotifier: Subject<any>) {
  const platform = inject(RtPlatform);
  const dialogSvc = inject(DialogService);
  const i18n = inject(I18nService);

  return (analyticsContext: string, tab: `${UserProfileTab}`) => {
    const ref = dialogSvc.openCustom(
      CurrentUserProfileDialogComponent,
      {
        injector: Injector.create({
          providers: [],
        }),
        width: DialogWidth.Small,
        mobileOptions: platform.IS_MOBILE
          ? {
              mobileDialog: true,
              mobileViewTitle: i18n.translate('tlc.current_user.mobile_heading'),
            }
          : undefined,
      },
      {
        analyticsContext,
        tab,
      },
    );

    ref.afterClosed.subscribe(event => {
      profileCloseNotifier.next(event);
    });

    return ref;
  };
}
